import { Component, Input } from '@angular/core';
import { ContextualActionComponent } from './contextual-action.component';


@Component({
  moduleId: module.id,
  selector: 'view-export-action',
  templateUrl: 'view-export-action.component.html',
  styleUrls: ['contextual-action.component.scss'],
})
export class ViewExportActionComponent extends ContextualActionComponent {

  onDownloadFileClick() {
    console.log('Download File: ', this.selectedRows);
  }
}
